export default "__VITE_ASSET__6fb8abb1__"